import {AppointmentBookingEnum} from 'main/analytics/gaTagsEnum';
import {ChatRoomsEnum, FeaturesEnum, HealthBookingEnum, HomeEnum} from 'presentation/constants';
import {getHealthStepPosition} from 'presentation/modules/booking/health/utils/getHealthStepPosition';
import {useBookingFlowStepsStore} from 'presentation/modules/booking/shared/store/useBookingFlowStepsStore';
import {useBookingStore} from 'presentation/modules/booking/shared/store/useBookingStore';
import {useCallChatRoom, useMediaQueries} from 'presentation/pages';

import {useNavigate} from 'react-router-dom';
import {UseHealthConfirmBookingModalsProps} from './types';
import {useResetBookingFlow} from 'presentation/modules/booking/shared/hooks/useResetBookingFlow';
import {useFeatureFlag} from 'presentation/hooks/useFeatureFlag';

export function useHealthConfirmBookingModals({
	handleBack,
	setTypeError,
	setBookingState,
}: UseHealthConfirmBookingModalsProps) {
	const {isMobile} = useMediaQueries();
	const {callChatRoom, IS_LOADING: callChatRoomIsLoading} = useCallChatRoom();
	const setActiveBookingFlowStep = useBookingFlowStepsStore(state => state.setBookingStep);
	const {resetBookingFlow} = useResetBookingFlow();
	const {protocolNumber, isManualLocation, isRebooking, bookingNumber} = useBookingStore(
		state => state.bookingData,
	);
	const navigate = useNavigate();
	const {isEnabled: isHideConfirmationBookingModalEnabled} = useFeatureFlag(
		FeaturesEnum.PORTAL_HIDE_CONFIRMATION_BOOKING_MODAL,
	);

	const alertModalpaperStyles = {
		style: {
			maxWidth: 420,
			margin: isMobile ? 16 : 'auto',
			flex: isMobile ? 1 : 'initial',
		},
	};

	const {LOCATION_STEP} = getHealthStepPosition({
		isManualLocation,
	});

	const dataTagIdSuccess = isRebooking
		? AppointmentBookingEnum.REALIZOU_REMARCACAO_CONSULTA
		: AppointmentBookingEnum.REALIZOU_AGENDAMENTO_COM_SUCESSO;

	const handleCallChatRoom = async () => {
		await callChatRoom(ChatRoomsEnum.APP);
	};

	const handleCloseErrorDialogState = () => {
		setTypeError(null);
		setBookingState(null);
	};

	const handleCloseAndRedirectToInitialFlow = (shouldRedirect?: boolean) => {
		setTypeError(null);
		setBookingState(null);

		if (shouldRedirect) {
			resetBookingFlow();
			setActiveBookingFlowStep(LOCATION_STEP);
		}
	};

	const handleCloseBackToProfissionalSelection = () => {
		setTypeError(null);
		setBookingState(null);

		handleBack();
	};

	const handleCloseAndRedirectToHome = (shouldRedirectToHome?: boolean) => {
		setTypeError(null);
		setBookingState(null);

		if (shouldRedirectToHome) {
			navigate(HomeEnum.HOME_PAGE);
		}
	};

	const handleCloseSuccessDialogState = () => {
		if (!bookingNumber) {
			setBookingState(null);
			return;
		}

		const path = HealthBookingEnum.HEALTH_BOOKING_CONFIRMATION.replace(':id', bookingNumber);

		navigate(path);
		setBookingState(null);
	};

	return {
		handleCallChatRoom,
		handleCloseErrorDialogState,
		handleCloseAndRedirectToInitialFlow,
		handleCloseBackToProfissionalSelection,
		handleCloseAndRedirectToHome,
		handleCloseSuccessDialogState,
		dataTagIdSuccess,
		alertModalpaperStyles,
		protocolNumber,
		callChatRoomIsLoading,
		navigate,
		isHideConfirmationBookingModalEnabled,
	};
}
